//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import imgUrl from '../../../screenshots/apply.png';
// import imgUrl from '../../assets/img/about1.jpg';
export default {
  name: 'userInfo',
  data: function data() {
    return {
      // imgUrl,
      version: "",
      frontversion: "1.6.0.5"
    };
  },
  created: function created() {
    this.getVersion();
  },
  methods: {
    getVersion: function getVersion() {
      var _this = this;

      var serach = {};
      this.$zybhttp.get('Business/GetSystemInfo', {}).then(function (res) {
        if (res.data.status == 0) {
          var d = res.data.msg;
          _this.version = d;
        } else {
          _this.$notify.error(res.message);
        }
      }).catch(function (err) {
        return _this.$notify.error('网络异常！获取列表失败！');
      });
    }
  }
};